import useReveal from "@/hooks/useReveal";
import { team } from "@/lib/home-content";

function LeaderCard({ p, i }) {
    const { ref, visible } = useReveal({ threshold: 0.15 });
    return (
        <div
            ref={ref}
            style={{ transitionDelay: `${(i % 3) * 80}ms` }}
            className={`reveal group rounded-3xl bg-white p-5 text-center ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_44px_rgba(43,80,255,0.14)] ${
                visible ? "is-visible" : ""
            }`}
        >
            <div className="relative mx-auto h-24 w-24 overflow-hidden rounded-full ring-4 ring-[var(--brand-soft)]">
                <img
                    src={p.img}
                    alt={p.name}
                    loading="lazy"
                    className={`h-full w-full object-cover ${p.bw ? "grayscale" : ""}`}
                />
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-[#0a0a0b]">{p.name}</h3>
            <div className="text-sm font-semibold text-[var(--brand)]">{p.role}</div>
            <p className="mt-3 text-sm leading-relaxed text-[#5b5b66]">{p.bio}</p>
        </div>
    );
}

function MemberCard({ p, i }) {
    const { ref, visible } = useReveal({ threshold: 0.15 });
    return (
        <div
            ref={ref}
            style={{ transitionDelay: `${(i % 4) * 70}ms` }}
            className={`reveal flex flex-col items-center rounded-2xl bg-white p-4 text-center ring-1 ring-black/5 ${
                visible ? "is-visible" : ""
            }`}
        >
            <div className="h-16 w-16 overflow-hidden rounded-full ring-2 ring-[var(--brand-soft)]">
                <img src={p.img} alt={p.name} loading="lazy" className="h-full w-full object-cover" />
            </div>
            <h4 className="mt-3 font-display text-sm font-bold text-[#0a0a0b]">{p.name}</h4>
            <div className="text-xs text-[#6b6b75]">{p.role}</div>
        </div>
    );
}

export default function Team() {
    const { ref, visible } = useReveal();

    return (
        <section id="about" data-testid="team-section" className="bg-[#f6f7fb] px-5 py-16 sm:py-20">
            <div className="mx-auto max-w-5xl">
                <div ref={ref} className={`reveal mb-10 text-center ${visible ? "is-visible" : ""}`}>
                    <span className="section-kicker">{team.kicker}</span>
                    <h2 className="section-title">{team.title}</h2>
                    <p className="section-lead mx-auto">{team.intro}</p>
                    <p className="section-lead mx-auto">{team.subtitle}</p>
                </div>

                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {team.leaders.map((p, i) => (
                        <LeaderCard key={p.name} p={p} i={i} />
                    ))}
                </div>

                <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4">
                    {team.members.map((p, i) => (
                        <MemberCard key={p.name} p={p} i={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
